import React, { ReactNode, useState } from 'react';
import { AppLayout, Header, BreadcrumbGroup, ContentLayout } from '@amzn/awsui-components-console';
import PortalSideNavigation from '../SideNavigation/SideNavigation';
import './PageLayoutWrapper.scss';
import PortalTopNavigation from '../TopNavigation/TopNavigation';

interface PageLayoutWrapperProps {
  /**
   * The content to be displayed in the main content area
   */
  children: ReactNode;
  /**
   * Main heading text or element
   */
  heading: string | ReactNode;
  /**
   * Background image for the hero section
   */
  backgroundImage?: string;
  /**
   * Optional breadcrumb items
   */
  breadcrumbItems?: {
    text: string;
    href: string;
  }[];
  /**
   * Whether to hide the navigation panel
   */
  navigationHide?: boolean;
  /**
   * Optional actions to display in the header (e.g., buttons)
   */
  headerActions?: ReactNode;
}

/**
 * A wrapper component for pages that includes top navigation, side navigation, and consistent page structure
 */
const PageLayoutWrapper: React.FC<PageLayoutWrapperProps> = ({
  children,
  heading,
  backgroundImage,
  breadcrumbItems,
  navigationHide = false,
  headerActions,
}) => {
  const [navigationOpen, setNavigationOpen] = useState(true);

  return (
    <>
      <PortalTopNavigation />
      <div className="app-layout-wrapper">
        <AppLayout
          navigation={<PortalSideNavigation />}
          navigationOpen={navigationOpen}
          onNavigationChange={(event) => setNavigationOpen(event.detail.open)}
          disableContentPaddings={true}
          toolsHide={true}
          navigationHide={navigationHide}
          content={
            <ContentLayout
              defaultPadding
              disableOverlap
              breadcrumbs={breadcrumbItems && <BreadcrumbGroup items={breadcrumbItems} />}
              headerBackgroundStyle={backgroundImage ? `center center/cover url(${backgroundImage})` : undefined}
              header={
                <Header variant="h1" actions={headerActions}>
                  <div className={backgroundImage ? 'page-header-white' : ''}>{heading}</div>
                </Header>
              }
            >
              {children}
            </ContentLayout>
          }
        />
      </div>
    </>
  );
};

export default PageLayoutWrapper;
